var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2825 17.5398L17.5299 30.8626L34.3697 1.84203L14.2825 17.5398Z",
    fill: "#EE3A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28963 9.75015L13.658 16.6405L33.7972 0.931712L1.28963 9.75015Z",
    fill: "#EE3A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupIcon);
export default __webpack_public_path__ + "static/media/signup-icon.3c74b495dab1397ceda7bba58f41e0e8.svg";
export { ForwardRef as ReactComponent };